import { withProps } from 'recompose'
import muiThemeable from 'material-ui/styles/muiThemeable'
import React from 'react'

import { chatRoomRoute } from '../app/routes'
import { getChatCfg, getGlobalChatroom } from '../app/selectors'
import ChatRoomIframe from '../addons/chat/ChatRoomIframe'
import content from '../content'

const ChatPage = ({ chatroom, muiTheme, chatCfg }) => {
  if (!chatroom || !chatCfg) {
    return null
  }
  const {
    appBar: { height: appBarHeight },
    custom: { metrics: { basePadding } },
  } = muiTheme
  const topPosition = appBarHeight + 2 * basePadding
  return (
    <div
      style={{
        width: '100%',
        height: `calc(100vh - ${topPosition}px)`,
      }}
    >
      <ChatRoomIframe
        src={chatRoomRoute(chatCfg.appId, chatroom.id)}
        title={`chat${chatroom.id}`}
      />
    </div>
  )
}

const withPageContent = withProps({
  chatroom: getGlobalChatroom(content),
  chatCfg: getChatCfg(content),
})

export default muiThemeable()(withPageContent(ChatPage))



// WEBPACK FOOTER //
// ./src/containers/ChatPage.js